<template>
  <div>
    <b-overlay opacity="0.5" :show="Esperar">
      <b-card class="w-50 my-4 m-auto text-white" bg-variant="info" body-class="text-center" footer-class="text-center">
        <template #header>
          <b-icon icon="person-fill" />
          <em> Acceso de usuarios</em>
        </template>

        <b-card-body>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="3"><label for="usuario">Usuario</label></b-col>
              <b-col sm="9"><b-form-input id="usuario" v-model="user.nombre" type="text"></b-form-input></b-col>
            </b-row>
            <b-row class="my-2">
              <b-col sm="3"><label for="clave">Contraseña</label></b-col>
              <b-col sm="9"><b-form-input id="clave" v-model="user.pass" type="password"></b-form-input></b-col>
            </b-row>
          </b-container>
        </b-card-body>
        <template #footer>
          <b-button :disabled="faltanDatos" @click="ingresar" variant="primary"> Ingresar </b-button>
        </template>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>

const md5 = require("md5");
import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyAG4ub4RPSGArL4DrOzPvuYOCoLOKvZHig",
    authDomain: "diazvelizexpress.firebaseapp.com",
    databaseURL: "https://diazvelizexpress-default-rtdb.firebaseio.com",
    projectId: "diazvelizexpress",
    storageBucket: "diazvelizexpress.appspot.com",
    messagingSenderId: "287052230881",
    appId: "1:287052230881:web:10ebb442697e24e21507a0"
  };


if (!firebase.apps.length) firebase.initializeApp(firebaseConfig);
else firebase.app();

const db = firebase.firestore();

export default {
  mounted() {
    this.Esperar = false;
  },
  firestore: {
    Usuarios: db.collection("Usuario"),
  },
  computed: {
    
    faltanDatos(){
      let rs=true;

      rs=!this.user.nombre ==false && !this.user.pass==false;

      return !rs;
    },
    codigo() {
      let n = this.user.nombre;
      let p = this.user.pass;

      if (n != "" && p != "") return md5(n.toUpperCase() + p);
      else return "";
    },
  },
  data() {
    return {
      user: { nombre: "", pass: "" },
      Esperar: true,
    };
  },
  methods: {
    ingresar() {
      this.Esperar = true;

      let Usuario = this.Usuarios.filter((user) => user.Hash == this.codigo)[0];

      if (Usuario) {
        db.collection("Usuario")
          .doc(Usuario.id)
          .update({ Ingreso: new Date(), URL: location.hostname })
          .then(() => {
            this.$session.start();
            this.$session.set("user", Usuario.Nombre);
            this.$session.set("userID", Usuario.id);
            this.$session.set('EsAdmin',Usuario.Admin)
            this.$root.$emit("EstadoUsuario", true);
            this.$router.push("/courier/home");
          });
      } else {
        this.user.pass='';
        this.$bvModal.msgBoxOk('Datos Incorrectos!')

      }

      this.Esperar = false;
    },
  },
};
</script>
